import instanciaAxios from './InterceptorAxios';

const servicioUsuario = {
	guardar(usuario) {
		return instanciaAxios.post('/usuario/guardar.json',usuario);
  },
  eliminar(usuario){
    return instanciaAxios.post('/usuario/eliminar.json',usuario);
  },
  buscarUsuario(usuario){
    return instanciaAxios.post('/usuario/buscarUsuario.json',usuario)
  },
  buscarCorreo(usuario){
    return instanciaAxios.post('usuario/buscarCorreo.json',usuario);
  },
  nuevoRegistroUsuario(usuario){
   return  instanciaAxios.post('/usuario/nuevoUsuario.json',usuario);
  },
  recuperarContrasena(usuario){
    return  instanciaAxios.post('/usuario/recuperarContrasena.json',usuario);
  },

  buscarUsuarioNombre(usuario){
    return  instanciaAxios.post('/usuario/buscarUsuarioNombre.json',usuario);
  }
  ,
  cambiosContrasena(){
    return instanciaAxios.post('usuario/cambioContrasena.json');
  },
  guardaCambioContrasena(usuario){
    return instanciaAxios.post('/usuario/guardaCambioContrasena.json',usuario);
  },
  usuarioSession(){
    return instanciaAxios.post('/usuario/sessionUsuario.json');
  },
  nombreDePerfil(){
    return instanciaAxios.post('/usuario/buscarNombrePerfil.json');
  },
  bucarUsuarioSession(){
    return instanciaAxios.post('/usuario/buscaUsuariosSession.json');
  },
  guardarContrasenaMiCuenta(usuario){
    return instanciaAxios.post('/usuario/guardarContrasenaMiCuenta.json',usuario);
  }
}

export default servicioUsuario;